import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, } from './types';
import { enhanceLimit, getURL, goBack, navigateToFAQ, navigateToLandingPage, navigation, needHelp, unPledge, verifyOtp } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { getAppHeader } from '../../../configs/config';
import sharedPropsService from "../../../SharedPropsService";
export const template = (creditStatus, isAllowed, platform, height, creditAmount, sanctionedLimit, totalOutstanding, detailData) => {
    return {
        layout: {
            id: ROUTE.UNPLEDGE_STATUS,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "unpledgeStatus", type: WIDGET.UNPLEDGE_STATUS }
            ],
        },
        datastore: {
            unpledgeStatus: {
                height: height,
                bankData: detailData,
                creditLimit: creditAmount,
                backAction: {
                    type: ACTION.MENU,
                    routeId: ROUTE.UNPLEDGE_STATUS,
                    payload: {}
                },
                profileAction: {
                    type: ACTION.UNPLEDGE,
                    payload: {},
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                },
                applyAction: {
                    type: ACTION.VERIFY_OTP,
                    payload: {},
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                },
                continuePress: {
                    type: ACTION.MARGIN_CALL,
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                },
                addBankAction: {
                    type: ACTION.NAVIGATE_DASHBOARD,
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                },
                needHelp: {
                    type: ACTION.NEED_HELP,
                    routeId: ROUTE.UNPLEDGE_STATUS,
                    payload: {}
                },
                sanctionedAmount: sanctionedLimit,
                totalOutstanding: totalOutstanding,
                backButtonClicked: false,
            },
        },
    };
};
export const unpledgeStatus = {
    onLoad: async ({ getHeight, instrumentTrack, network }, { target }) => {
        const creditStatus = await SharedPropsService.getCreditStatus();
        const user = await SharedPropsService.getUser();
        const creditAmount = user.linkedCredits[0].actualLoanAmount;
        const totalOutstanding = parseInt(user.linkedCredits[0]?.principalOutStandingAmount) + user.linkedCredits[0]?.outstandingInterestDue || 0 + user.linkedCredits[0]?.chargesDue + user.linkedCredits[0]?.penalInterestDue || 0;
        console.warn("TOTAL RECEIVED HERE", totalOutstanding, target);
        const sanctionedLimit = user.linkedCredits[0].approvedCreditAmount;
        const requestOptions = {
            method: 'GET',
            headers: await getAppHeader(),
        };
        instrumentTrack('MANAGE_LIMIT_PAGE_VIEWED');
        const platform = await sharedPropsService.getAppPlatform();
        return Promise.resolve(template(creditStatus, true, platform, getHeight(), creditAmount, sanctionedLimit, totalOutstanding, target));
    },
    actions: {
        [ACTION.EMAIL]: getURL,
        [ACTION.NAVIGATION]: navigation,
        [ACTION.MENU]: goBack,
        [ACTION.UNPLEDGE]: unPledge,
        [ACTION.ENHANCE_LIMIT]: enhanceLimit,
        [ACTION.MARGIN_CALL]: navigateToFAQ,
        [ACTION.VERIFY_OTP]: verifyOtp,
        [ACTION.NAVIGATE_DASHBOARD]: navigateToLandingPage,
        [ACTION.NEED_HELP]: needHelp
    },
};
